// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__vswFi","Label":"BuildControl_Label__3YjKx","Less":"BuildControl_Less__3Qdnq","More":"BuildControl_More__1sNW4"};